// removed by extract-text-webpack-plugin
module.exports = {"search-icon":"search-icon__30lVb","input-placeholder":"input-placeholder__1j1ip","autocomplete-results":"autocomplete-results__3-8dT","hover-affect":"hover-affect__2EULP","resultSearch":"resultSearch__2nRiy","search-container":"search-container__TY6N0","search-input":"search-input__15YBs","search-help":"search-help__1ocmI","size-large":"size-large__unj1Y","selected":"selected__8ERdB"};


//////////////////
// WEBPACK FOOTER
// ./styles/home/homeSearch.scss
// module id = 440
// module chunks = 68